@if (showCookieConsent) {
	<div class="cookie-consent-container bg-white">
		<div class="cookie-consent">
			<h2 class="cookie-consent-title">
				{{ 'common.cookie.consent.title' | translate }}
			</h2>
			<mat-tab-group dynamicHeight="true">
				<mat-tab label="{{ 'common.cookie.consent.accept' | translate }}">
					<span class="cookie-consent-text">
						{{ 'common.cookie.consent.info' | translate }}
					</span>
					<div class="options">
						<form [formGroup]="form">
							<app-slider-toggle-input
								[disabled]="true"
								[value]="true"
								[label]="'common.cookie.options.necessary' | translate"
								formControlName="default"
							/>
							@if (isGoogleAnalyticsEnabled === 'true') {
								<app-slider-toggle-input
									[value]="isGoogleAnalyticsChecked"
									[label]="'common.cookie.options.google-analytics' | translate"
									(valueChanged)="changeGA($event)"
									formControlName="googleAnalytics"
								/>
							}
						</form>
					</div>
				</mat-tab>
				<mat-tab label="{{ 'common.cookie.consent.additional-info' | translate }}">
					<div class="options-detail">
						<form [formGroup]="form">
							<div class="detailed-option">
								<app-slider-toggle-input
									[label]="'common.cookie.options.necessary' | translate"
									[disabled]="true"
									[value]="true"
									formControlName="default"
								/>
								<span>
									{{ 'common.cookie.consent.details.necessary' | translate }}
								</span>
							</div>
							@if (isGoogleAnalyticsEnabled === 'true') {
								<div class="detailed-option">
									<app-slider-toggle-input
										[value]="isGoogleAnalyticsChecked"
										[label]="'common.cookie.options.google-analytics' | translate"
										(valueChanged)="changeGA($event)"
										formControlName="googleAnalytics"
									/>
									<span>
										{{ 'common.cookie.consent.details.analytics' | translate }}
									</span>
								</div>
							}
						</form>
					</div>
				</mat-tab>
			</mat-tab-group>

			<div class="option-buttons">
				<button mat-raised-button color="primary" class="option-button" (click)="acceptCookies(true)">
					{{ 'common.dialog.accept' | translate }}
				</button>
				<button mat-stroked-button color="primary" class="option-button" (click)="acceptCookies(false)">
					{{ 'common.dialog.accept-selected' | translate }}
				</button>
				<button mat-stroked-button color="primary" class="option-button" (click)="closeCookieConsent()">
					{{ 'common.dialog.decline' | translate }}
				</button>
			</div>
		</div>
	</div>
}
